import { Flex, Box, SimpleGrid } from '@chakra-ui/core'
import React from 'react'
import { BoardHeader } from '../commonUI/BoardHeader'
import { UserCard } from './UserCard'
import { UsersTable } from './UsersTable'
import { NoResults } from 'components/CommonComponents/GroupsTree/NoResults'
import { useUserModals } from './UserModalsManagerContext'
import { IConfigRetailUser, RootState } from 'constants/interfaces'
import { useSelector } from 'react-redux'
import useLocaleText from 'components/useLocaleText'

interface Props {
  users: IConfigRetailUser[]
  viewMode: 'grid' | 'table'
  onChangeViewMode: () => void
  searchQuery: string
  onSearch: (value: string) => void
}

export const UsersBoardContent: React.FC<Props> = ({ users, viewMode, onChangeViewMode, searchQuery, onSearch }) => {
  const { openUserModal } = useUserModals()
  const theme = useSelector((state: RootState) => state.general.theme)
  const admin_create_user = useLocaleText('admin_create_user')
  const admin_number_of_users = useLocaleText('admin_number_of_users')

  return (
    <Flex direction="column">
      <BoardHeader
        title={admin_number_of_users}
        count={users.length}
        createButtonText={admin_create_user}
        onSearch={onSearch}
        onCreate={() => openUserModal()}
        viewMode={viewMode}
        onViewModeChange={onChangeViewMode}
        theme={theme}
        searchValue={searchQuery}
      />

      <Box position="relative" zIndex={1}>
        {users.length > 0 ? (
          viewMode === 'grid' ? (
            <SimpleGrid columns={{ base: 1, sm: 2, md: 2, lg: 3 }} spacing={4}>
              {users.map((user) => (
                <UserCard key={user.uid} user={user} />
              ))}
            </SimpleGrid>
          ) : (
            <UsersTable users={users} />
          )
        ) : (
          <NoResults />
        )}
      </Box>
    </Flex>
  )
}
